import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {SpeedupInfo, UpdateInfo} from "@/store/artifact/types";
import TimeUtils from "@/utils/time-utils";
import Text = Phaser.GameObjects.Text;
import {ArtifactBasePanel} from "@/scenes.ui/artifact-base-panel";
import Container = Phaser.GameObjects.Container;
import ArtifactUtils from "@/utils/artifact-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ArtifactSpeedupPanel extends ArtifactBasePanel {

    private timeText: Text | undefined;
    private updatingTill: number | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, slotX: number, slotY: number,
                si: SpeedupInfo | UpdateInfo, speedupCallback: () => unknown, container: Container) {
        super(scene, canvas, slotX, slotY, container);
        this.setScale(1 / CU.S, 1 / CU.S);
        this.updatingTill = si.updatingTill;

        const title = TextUtils.addTextByFamily(this.scene, si.currName.toUpperCase(), 0, -282, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let updateText = TextUtils.addTextByFamily(scene, Tr('idet.uluchshenie').toUpperCase(),
            0, -200, '#ffe8ba', 16, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let lightFrom = SpriteUtils.addSprite(this.scene, -90, -120, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 0.8);
        let lightTo = SpriteUtils.addSprite(this.scene, 90, -120, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 0.8);
        let itemFrom = SpriteUtils.addSprite(this.scene, -90, -120, si.atlasKey, si.currImageKey);
        let fromText = TextUtils.addTextAdvanced(scene, ArtifactUtils.getEffectText(si.effectType, si.currLevelValue), -90, -80,
            '#e0e0e0', 15, 'normal', 150, 'center', 2, Fonts.ARIAL_MT);
        let itemArr = SpriteUtils.addSprite(this.scene, 0, -120, Keys.ATLAS_PROFILE, Keys.UI_ART_ARR);
        let itemTo = SpriteUtils.addSprite(this.scene, 90, -120, si.atlasKey, si.nextImageKey);
        let toText = TextUtils.addTextAdvanced(scene, ArtifactUtils.getEffectText(si.effectType, si.nextLevelValue), 90, -80,
            '#85ff85', 15, 'normal', 150, 'center', 2, Fonts.ARIAL_MT);

        let timeLabel = TextUtils.addTextAdvanced(scene, Tr('ostalos.vremeni'), 0, 5,
            '#716f6a', 12, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        const remainSec = Math.floor((si.updatingTill - TimeUtils.getServerTimeMs()) / 1000);

        this.timeText = TextUtils.addTextAdvanced(scene, TimeUtils.getDurationText(remainSec), 0, 45,
            '#ae9d26', 15, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        let speedupButton = new SquareButton(this.scene, 0, 190, 0, Keys.UI_ART_GREEN_BUTTON,
            undefined, Keys.IC_100_MITHRIL, Tr('uskorit'), false);

        speedupButton.setCallback(() => {
            if (this.isOnTop()) {
                speedupCallback();
            }
        });
        let speedupPriceText = TextUtils.addText(scene,
            String(si.speedupPrice), 0, 224, '#ffffff', 25, 'bold', 200);

        this.add([title, this.timeText, speedupButton, speedupPriceText, updateText, lightFrom, lightTo, itemFrom,
            fromText, itemArr, itemTo, toText, timeLabel]);
    }

    public refreshTimer(): void {
        if (this.active && this.timeText && this.updatingTill) {
            const remainSec = Math.floor((this.updatingTill - TimeUtils.getServerTimeMs()) / 1000);
            this.timeText.setText(remainSec > 0 ? TimeUtils.getDurationText(remainSec) : Tr('gotovo'));

            if(remainSec <= 0){
                this.active = false;
                this.close();
            }
        }
    }
}
